const popUppp = document.querySelector('.buy_more_save_more');
function buyMore() {
  if (popUppp) { popUppp.classList.toggle('active'); }
}
function hideBuyMore() {
  if (popUppp) { popUppp.classList.remove('active'); }
}
document.querySelectorAll('.buy_more_save_more .Qty__buttons').forEach(button => {
  button.addEventListener('click', (e) => {
    e.stopPropagation();
    document.querySelector('.buy_more_save_more').classList.remove('active');
  });
});
document.addEventListener('click', function (e) {
  const popup = document.querySelector('.buy_more_save_more');
  const opener = document.querySelector('.pop_up_opener_buy_more_save_more');
  if (popup && opener) {
    if (!popup.contains(e.target) && !opener.contains(e.target)) { hideBuyMore(); }
  }
});

function updatePrices(activeElement) {
  function fmt(cents) {
    const format = window.bundleMoneyFormat || '{{amount}}';
    const amount = (cents / 100).toFixed(2);
    return format
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100).toString())
      .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
      .replace('{{amount}}', amount);
  }
  const compare_price = parseFloat(activeElement.dataset.compare_price);
  const original_price = parseFloat(activeElement.dataset.price);
  const priceBlock = document.querySelector('.price-block');
  if (!priceBlock) return;
  const saleEl = priceBlock.querySelector('.sale-price');
  const compareEl = priceBlock.querySelector('.regular-price');
  if (saleEl) saleEl.textContent = fmt(original_price);
  if (compareEl) compareEl.textContent = fmt(compare_price);
}

document.addEventListener('DOMContentLoaded', () => {
  const bundlePack = document.querySelectorAll('.Qty__buttons');
  const qtyToCart = document.querySelector('#added_to_cart_qty');
  const selectedItemContainer = document.querySelector('.selected_item');
  const productColors = document.querySelectorAll('.variant_featured_image_bundle');
  let allPlaceholders = [];
  // selectedOptions[position] = { value: string, swatchStyle: string }
  let selectedOptions = {};
  let currentClickedSwatch = null;

  if (!selectedItemContainer) return;

  // Fetch ALL variants via Storefront API (handles >250 variants from Shopify Bundles)
  const _storefrontToken = window.bundleStorefrontToken;
  const _productId = window.featureProduct && window.featureProduct.id;
  if (_storefrontToken && _productId) {
    (async function fetchRemainingVariants() {
      let cursor = null;
      let hasNext = true;
      const existing = new Set((window.allBundleVariants || []).map(v => v.id));
      while (hasNext) {
        const afterClause = cursor ? `, after: "${cursor}"` : '';
        const query = `{ product(id: "gid://shopify/Product/${_productId}") { variants(first: 250${afterClause}) { pageInfo { hasNextPage endCursor } edges { node { id availableForSale selectedOptions { value } } } } } }`;
        try {
          const res = await fetch('/api/2024-01/graphql.json', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': _storefrontToken },
            body: JSON.stringify({ query })
          });
          const json = await res.json();
          const variantsData = json.data && json.data.product && json.data.product.variants;
          if (!variantsData) break;
          variantsData.edges.forEach(e => {
            const numId = parseInt(e.node.id.split('/').pop());
            if (!existing.has(numId)) {
              existing.add(numId);
              window.allBundleVariants = window.allBundleVariants || [];
              window.allBundleVariants.push({ id: numId, options: e.node.selectedOptions.map(o => o.value), available: e.node.availableForSale });
            }
          });
          hasNext = variantsData.pageInfo.hasNextPage;
          cursor = variantsData.pageInfo.endCursor;
        } catch(e) { break; }
      }
    })();
  }

  function allVariants() {
    // allBundleVariants contains ALL variants (output via Liquid loop, not truncated like product | json)
    if (window.allBundleVariants && window.allBundleVariants.length > 0) return window.allBundleVariants;
    return window.featureProduct ? window.featureProduct.variants : [];
  }

  function findMatchedVariant() {
    if (!window.featureProduct) return null;
    const totalOptions = window.featureProduct.options.length;
    const allSelected = Object.keys(selectedOptions).length === totalOptions;
    if (!allSelected) return null;
    return allVariants().find(variant =>
      variant.options.every((val, idx) => selectedOptions[idx + 1] && selectedOptions[idx + 1].value === val)
    ) || null;
  }

  // Find variant from a plain {position: value} map (used when re-matching slots on size change)
  function findVariantForSlot(slotOpts) {
    return allVariants().find(variant =>
      variant.options.every((val, idx) => slotOpts[idx + 1] === val)
    ) || null;
  }

  function rematchAllSlots() {
    document.querySelectorAll('.fake_item_shape .slot-swatches').forEach(container => {
      const circles = container.querySelectorAll('.slot-swatch-circle[data-option-value]');
      if (!circles.length) return;
      const slotOpts = {};
      circles.forEach(c => { slotOpts[parseInt(c.dataset.optionPos)] = c.dataset.optionValue; });
      // Merge in current size selections
      document.querySelectorAll('.bundle-size-select').forEach(s => {
        slotOpts[parseInt(s.dataset.optionPosition)] = s.value;
      });
      const matched = findVariantForSlot(slotOpts);
      if (matched) container.setAttribute('data-product_var', matched.id);
    });
    updateSelectedVariants();
  }

  function checkCombinationAvailability() {
    if (!window.featureProduct) return;
    const variants = allVariants();

    // Build current selectedOptions as plain {pos: value} map
    const currentOpts = {};
    Object.entries(selectedOptions).forEach(([pos, data]) => { currentOpts[parseInt(pos)] = data.value; });

    // Update size dropdown: disable sizes that have no available variant with current color selections
    document.querySelectorAll('.bundle-size-select').forEach(sel => {
      const sizePos = parseInt(sel.dataset.optionPosition);
      const colorPositions = Object.keys(currentOpts).map(Number).filter(p => p !== sizePos);
      const allColorsSelected = colorPositions.length >= document.querySelectorAll('.bundle-options-container .colors_main_container').length;
      if (!allColorsSelected) return; // don't update until all colors chosen
      Array.from(sel.options).forEach(opt => {
        const testOpts = { ...currentOpts, [sizePos]: opt.value };
        const matched = variants.find(v => v.options.every((val, idx) => testOpts[idx + 1] === val));
        // Only disable if variant exists and is sold out (not if combination simply doesn't exist)
        opt.disabled = matched ? !matched.available : false;
        opt.style.color = (matched && !matched.available) ? '#bbb' : '';
      });
      // If current selection is disabled, switch to first available
      if (sel.options[sel.selectedIndex] && sel.options[sel.selectedIndex].disabled) {
        const firstAvail = Array.from(sel.options).find(o => !o.disabled);
        if (firstAvail) { sel.value = firstAvail.value; sel.dispatchEvent(new Event('change')); }
      }
    });

    // Update color swatches: only mark unavailable when ALL other color groups are already selected
    const totalColorGroups = document.querySelectorAll('.bundle-options-container .colors_main_container').length;
    const colorPositionsSelected = Object.keys(currentOpts).filter(p => {
      const sel = document.querySelector('.bundle-size-select[data-option-position="' + p + '"]');
      return !sel; // exclude size positions, keep only color positions
    }).length;

    document.querySelectorAll('.bundle-color-swatch').forEach(swatch => {
      const optPos = parseInt(swatch.dataset.optionIndex);
      const swatchValue = swatch.title;
      // Count how many other color groups (not this one) are selected
      const otherColorsSelected = Object.keys(currentOpts).filter(p => {
        const isSizeOpt = !!document.querySelector('.bundle-size-select[data-option-position="' + p + '"]');
        return !isSizeOpt && parseInt(p) !== optPos;
      }).length;
      // Only check availability if all other color groups are already chosen
      if (otherColorsSelected < totalColorGroups - 1) {
        swatch.classList.remove('swatch-unavailable');
        return;
      }
      const testOpts = { ...currentOpts, [optPos]: swatchValue };
      const matchedVariant = variants.find(v =>
        Object.entries(testOpts).every(([pos, val]) => v.options[parseInt(pos) - 1] === val)
      );
      // Only mark unavailable if variant EXISTS but is sold out.
      // If variant doesn't exist (combination not set up), leave as selectable.
      const isUnavailable = matchedVariant !== undefined && !matchedVariant.available;
      swatch.classList.toggle('swatch-unavailable', isUnavailable);
    });
  }

  // Alt-text based media lookup, same technique as the main variant-picker popup
  // (main-product.liquid). Preferred over `data-image`/`v.featured_image` because those are
  // sourced from a single arbitrary full-combination variant per swatch (Shopify only lets a
  // variant have ONE image covering every option at once) and are frequently blank or wrong
  // for a specific option value — alt text tagged per-photo (e.g. "Luggage Cover Black") is
  // reliable and doesn't depend on which other options happen to be selected.
  function getBundleMediaMaps() {
    var mapKey = Object.keys(window).find(function (k) { return k.indexOf('__voltaMediaMap_') === 0; });
    var srcKey = Object.keys(window).find(function (k) { return k.indexOf('__voltaMediaSrc_') === 0; });
    return { mediaMap: mapKey ? window[mapKey] : null, srcMap: srcKey ? window[srcKey] : null };
  }

  function findBundleMedia(productPrefix, colorValue, mediaMap) {
    if (!mediaMap) return null;
    var needleColor = colorValue.toLowerCase().trim();
    var prefixWords = productPrefix.toLowerCase().trim().split(/\s+/);
    for (var i = 0; i < prefixWords.length; i++) {
      var np = prefixWords.slice(i).join(' ');
      for (var id in mediaMap) {
        var a = (mediaMap[id] || '').trim();
        if (a.indexOf(np) !== -1 && a.endsWith(needleColor)) return id;
      }
    }
    for (var j = 0; j < prefixWords.length; j++) {
      var np2 = prefixWords.slice(j).join(' ');
      for (var id2 in mediaMap) {
        var a2 = (mediaMap[id2] || '').trim();
        if (a2.indexOf(np2) !== -1 && a2.indexOf(needleColor) !== -1) return id2;
      }
    }
    // Deliberately no looser "any media ending in this color" fallback here — that's exactly
    // the kind of cross-product match (grabbing another component's photo) this replaces.
    return null;
  }

  function openVariantPopup() {
    const popup = document.querySelector('.variant_popup_custom');
    if (popup) { popup.classList.add('active'); document.body.classList.add('overflow-hidden'); }
  }

  const closeBtn = document.querySelector('.variant_popup_custom .icon-close-small');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      document.querySelector('.variant_popup_custom').classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    });
  }

  document.addEventListener('click', function (event) {
    const popup = document.querySelector('.variant_popup_custom');
    if (!popup) return;
    if (!popup.contains(event.target) && popup.classList.contains('active') && !event.target.classList.contains('variant_featured_image_bundle')) {
      popup.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }
  });

  // Size dropdowns: update selectedOptions + update availability indicators
  document.querySelectorAll('.bundle-size-select').forEach(sel => {
    const pos = parseInt(sel.dataset.optionPosition);
    selectedOptions[pos] = { value: sel.value, swatchStyle: '' };
    sel.addEventListener('change', () => {
      selectedOptions[pos] = { value: sel.value, swatchStyle: '' };
      checkCombinationAvailability();
    });
  });

  function renderPlaceholders(qty) {
    selectedItemContainer.innerHTML = '';
    allPlaceholders = [];
    for (let i = 0; i < qty; i++) {
      const el = document.createElement('div');
      el.classList.add('fake_item_shape');
      el.setAttribute('data-number', i + 1);
      el.innerHTML = `<index>${i + 1}</index><p class="remove-btn">Remove</p>`;
      selectedItemContainer.appendChild(el);
      allPlaceholders.push(el);
    }
    enableRemoveFunction();
  }

  function enableRemoveFunction() {
    document.querySelectorAll('.fake_item_shape .remove-btn').forEach(btn => {
      btn.addEventListener('click', function (e) {
        const parent = e.target.closest('.fake_item_shape');
        const number = parent.dataset.number;
        parent.innerHTML = `<index>${number}</index><p class="remove-btn">Remove</p>`;
        updateSelectedVariants();
        enableRemoveFunction();
      });
    });
  }

  function AddtocartButtonUpdate() { /* no-op: popup button always enabled */ }

  function updateSelectedVariants() {
    window.selectedVariants = Array.from(
      document.querySelectorAll('.fake_item_shape [data-product_var]')
    ).map(el => el.getAttribute('data-product_var'));
  }

  const activePack = document.querySelector('.Qty__buttons.active');
  if (activePack) {
    const initialQty = parseInt(activePack.dataset.qty);
    if (qtyToCart) qtyToCart.value = initialQty;
    renderPlaceholders(initialQty);
    updatePrices(activePack);
  }

  bundlePack.forEach(pack => {
    pack.addEventListener('click', () => {
      bundlePack.forEach(p => p.classList.remove('active'));
      pack.classList.add('active');
      const dataQty = parseInt(pack.dataset.qty);
      if (qtyToCart) qtyToCart.value = dataQty;
      renderPlaceholders(dataQty);
      hideBuyMore();
      updatePrices(pack);
    });
  });

  productColors.forEach(variantImage => {
    variantImage.addEventListener('click', () => {
      const optPos = parseInt(variantImage.dataset.optionIndex);
      const varTitle = variantImage.title;
      const swatchStyle = variantImage.style.cssText;

      // Mark as active in main page
      const group = variantImage.closest('.colors_main_container');
      if (group) group.querySelectorAll('.variant_featured_image_bundle').forEach(s => s.classList.remove('active-swatch'));
      variantImage.classList.add('active-swatch');

      // Store selection
      selectedOptions[optPos] = { value: varTitle, swatchStyle: swatchStyle };
      checkCombinationAvailability();

      // Update popup image — prefer alt-text matching against the product's own media
      // (same technique as the main variant-picker popup); fall back to data-image, then to
      // any variant sharing this option value, in that order.
      const popupImg = document.getElementById('bundle-popup-img');
      if (popupImg) {
        let imgSrc = null;
        const optionName = window.featureProduct && window.featureProduct.options && window.featureProduct.options[optPos - 1];
        if (optionName) {
          const prefix = optionName.toLowerCase().replace(/\s*\(?\s*colou?r\s*\)?\s*$/i, '').trim();
          const maps = getBundleMediaMaps();
          const mediaId = findBundleMedia(prefix, varTitle, maps.mediaMap);
          if (mediaId && maps.srcMap) imgSrc = maps.srcMap[mediaId];
        }
        if (!imgSrc) imgSrc = variantImage.dataset.image;
        if (!imgSrc && window.featureProduct && window.featureProduct.variants) {
          const optIdx = optPos - 1;
          const matched = window.featureProduct.variants.find(v => v.options[optIdx] === varTitle && v.featured_image);
          if (matched && matched.featured_image) imgSrc = matched.featured_image.src;
        }
        if (imgSrc) popupImg.src = imgSrc;
      }

      openVariantPopup();
      currentClickedSwatch = variantImage;
    });
  });

  const popupSelectBtn = document.querySelector('#add_to_cart_popup_button');
  if (popupSelectBtn) {
    popupSelectBtn.addEventListener('click', function () {
      // This button adds the current clicked swatch's selection to the next empty slot
      if (!currentClickedSwatch) return;

      // Add the swatch circle to the next empty slot
      let slotFound = false;
      for (let i = 0; i < allPlaceholders.length; i++) {
        const placeholder = allPlaceholders[i];
        // Find if this option position already has a circle in this slot
        const existingCircles = placeholder.querySelectorAll('.slot-swatch-circle');
        const optPos = parseInt(currentClickedSwatch.dataset.optionIndex);
        const alreadySet = Array.from(existingCircles).some(c => c.dataset.optionPos == optPos);

        if (!alreadySet) {
          slotFound = true;
          // Remove existing circle for this optPos if present (re-selection)
          existingCircles.forEach(c => { if (c.dataset.optionPos == optPos) c.remove(); });

          // Get or create the swatch container for this slot
          let swatchContainer = placeholder.querySelector('.slot-swatches');
          if (!swatchContainer) {
            swatchContainer = document.createElement('div');
            swatchContainer.classList.add('slot-swatches');
            const existingIndex = placeholder.querySelector('index');
            if (existingIndex) existingIndex.remove();
            placeholder.insertBefore(swatchContainer, placeholder.querySelector('p'));
          }

          const circle = document.createElement('div');
          circle.classList.add('slot-swatch-circle');
          circle.dataset.optionPos = optPos;
          circle.dataset.optionValue = currentClickedSwatch.title;
          circle.dataset.componentVariantId = currentClickedSwatch.dataset.componentVariantId || '';
          circle.style.cssText = currentClickedSwatch.style.cssText;
          swatchContainer.appendChild(circle);

          // If all color options are filled for this slot, store variant ID
          const colorSwatchGroups = document.querySelectorAll('.bundle-options-container .colors_main_container');
          if (swatchContainer.querySelectorAll('.slot-swatch-circle').length >= colorSwatchGroups.length) {
            const matched = findMatchedVariant();
            if (matched) swatchContainer.setAttribute('data-product_var', matched.id);
          }
          break;
        }
      }

      if (!slotFound) {
        // All slots full — show a brief message near the swatches
        let toast = document.getElementById('volta-slots-full-msg');
        if (!toast) {
          toast = document.createElement('p');
          toast.id = 'volta-slots-full-msg';
          toast.style.cssText = 'margin:6px 0 0;font-size:13px;color:#c0392b;display:none;';
          toast.textContent = (window.bundleStrings && window.bundleStrings.slotsFull) || 'All colors selected. Remove one to choose a different color.';
          const colorContainers = document.querySelectorAll('.bundle-options-container .colors_main_container');
          const lastContainer = colorContainers[colorContainers.length - 1];
          if (lastContainer) lastContainer.after(toast);
        }
        toast.style.display = 'block';
        clearTimeout(toast._hideTimer);
        toast._hideTimer = setTimeout(() => { toast.style.display = 'none'; }, 3000);
      }

      document.querySelector('.variant_popup_custom').classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      updateSelectedVariants();
    });
  }

  // Add to cart
  const bundleCartBtn = document.querySelector('#bundle-add-to-cart');
  if (bundleCartBtn) {
    bundleCartBtn.addEventListener('click', function () {
      console.log('[Bundle] allBundleVariants count:', window.allBundleVariants ? window.allBundleVariants.length : 'NOT SET');
      const computed = [];
      document.querySelectorAll('.fake_item_shape .slot-swatches').forEach((container, si) => {
        const circles = container.querySelectorAll('.slot-swatch-circle[data-option-value]');
        if (!circles.length) return;
        const slotOpts = {};
        circles.forEach(c => { slotOpts[parseInt(c.dataset.optionPos)] = c.dataset.optionValue; });
        document.querySelectorAll('.bundle-size-select').forEach(s => {
          slotOpts[parseInt(s.dataset.optionPosition)] = s.value;
        });
        console.log('[Bundle] Slot', si, 'slotOpts:', JSON.stringify(slotOpts));
        const matched = findVariantForSlot(slotOpts);
        console.log('[Bundle] Slot', si, 'matched:', matched ? matched.id : 'NULL');
        if (matched) computed.push(matched.id);
      });

      if (!computed.length) {
        alert('Seleciona primeiro as cores de todos os produtos.'); return;
      }
      const expectedQty = qtyToCart ? parseInt(qtyToCart.value) : 1;
      if (computed.length < expectedQty) {
        alert('Uma das combinações de cores selecionadas não está disponível. Por favor experimenta uma combinação diferente.'); return;
      }
      const items = computed.map(id => ({ id: parseInt(id), quantity: 1 }));
      bundleCartBtn.disabled = true;
      bundleCartBtn.textContent = bundleCartBtn.dataset.labelAdding || 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })
        .then(r => { if (!r.ok) return r.json().then(e => Promise.reject(e)); return r.json(); })
        .then(() => fetch('/?sections=cart-drawer'))
        .then(r => r.json())
        .then(sections => {
          if (sections['cart-drawer']) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
            const newDrawer = doc.querySelector('#CartDrawer');
            const currentDrawer = document.querySelector('#CartDrawer');
            if (newDrawer && currentDrawer) currentDrawer.innerHTML = newDrawer.innerHTML;
          }
          fetch('/cart.js').then(r => r.json()).then(cart => {
            document.querySelectorAll('.cart-icon-bubble-count').forEach(el => { el.textContent = cart.item_count; });
          });
          const cartDrawerEl = document.querySelector('cart-drawer');
          const overlay = document.querySelector('body > .overlay');
          if (cartDrawerEl) {
            cartDrawerEl.classList.add('animate', 'active');
            if (overlay) overlay.classList.add('open');
            document.body.classList.add('hidden');
          }
          bundleCartBtn.disabled = false;
          bundleCartBtn.textContent = bundleCartBtn.dataset.labelCart || 'Add to cart';
        })
        .catch(err => {
          console.error('[Bundle] Cart add error:', err);
          alert('Erro ao adicionar: ' + (err && err.description ? err.description : JSON.stringify(err)));
          bundleCartBtn.disabled = false;
          bundleCartBtn.textContent = bundleCartBtn.dataset.labelCart || 'Add to cart';
        });
    });
  }
});